import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import { Link } from "react-router-dom"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import JDate from "jalali-date"
import Switch from "@material-ui/core/Switch"
import Snackbar from "@material-ui/core/Snackbar"

import Divider from "@material-ui/core/Divider"
import TableSortLabel from "@material-ui/core/TableSortLabel"
import Moment from "moment"
import NumberFormat from "react-number-format"
import HighlightOffIcon from "@material-ui/icons/HighlightOff"

import Collapse from "@material-ui/core/Collapse"
import Avatar from "@material-ui/core/Avatar"
import * as constants from "../constants"
import "react-modern-calendar-datepicker/lib/DatePicker.css"
import Calendar from "react-modern-calendar-datepicker"
import OutlinedInput from "@material-ui/core/OutlinedInput"
import IconButton from "@material-ui/core/IconButton"
import InputAdornment from "@material-ui/core/InputAdornment"
import FloatingLabelInput from "./FloatingLabelInput"
import Fab from "@material-ui/core/Fab"
import VoiceOverOffIcon from "@material-ui/icons/VoiceOverOff"
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver"
import CloseIcon from "@material-ui/icons/Close"
import CheckIcon from "@material-ui/icons/Check"
import Select from "react-select"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogContentText from "@material-ui/core/DialogContentText"
import DialogTitle from "@material-ui/core/DialogTitle"

const styles = (theme) => ({
      paperrtl: {
            marginTop: theme.spacing(0),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
      },
      paper: {
            display: "flex",
            flexWrap: "wrap",
            "& > *": {
                  margin: theme.spacing(1),
                  width: theme.spacing(20),
            },
      },
      root: {
            width: "100%",
            margin: "15px",
            padding: "8px",
            direction: "rtl",
      },
      container: {
            maxHeight: 400,
      },
      large: {
            width: theme.spacing(10),
            height: theme.spacing(10),
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

const optionDiscMode = [
      { value: "fix", label: "مبلغ ثابت" },
      { value: "percent", label: "درصد" },
]

class ChangeMarketerComission extends Component {
      cookies = new Cookies()
      temp333
      constructor(props) {
            super(props)
            this.state = {
                  redirect: false,
                  errstr: "",
                  errstatus: false,
                  okstatus: false,
                  requestinfos: [],
                  agentInfofilter: [],
                  rowsPerPage: 10,
                  page: 0,
                  marketer_commission_defult_id: "",
                  marketer_commission_defult_percent: "",
                  marketer_commission_defult_wage: "",
                  selectedFieldinsurance: "",
                  selectedFilterFieldinsurance: { value: 0, label: "همه انواع بازاریاب" },
                  selectedMarketerMode: "",
                  selectedFilterMarketerMode: { value: 0, label: "همه انوع بازاریاب" },
                  marketer_mode_color: "",
                  fieldinsurance_logo_url: "",
                  orderBy: "marketer_commission_defult_id",
                  order: "desc",
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  newMarketerComission: true,
                  optionMarketerMode: [],
                  optionFilterMarketerMode: [],
                  optionFieldinsurance: [],
                  optionFilterFieldinsurance: [],
            }
      }

      handleChangeAmount = (event) => {
            this.setState({ marketer_commission_defult_percent: event.target.value })
      }

      handleChangeDefultPercent = (event) => {
            this.setState({ marketer_commission_defult_wage: event.target.value })
      }

      handleFieldinsurance = (selectedFieldinsurance) => {
            this.setState({ selectedFieldinsurance: selectedFieldinsurance, fieldinsurance_logo_url: selectedFieldinsurance.logo })
      }

      handleFilterFieldinsurance = (selectedFilterFieldinsurance) => {
            this.setState({ selectedFilterFieldinsurance: selectedFilterFieldinsurance }, () => {
                  this.filterMarketerComission()
            })
      }
      handleMarketerMode = (selectedMarketerMode) => {
            this.setState({ selectedMarketerMode: selectedMarketerMode, marketer_mode_color: selectedMarketerMode.logo })
      }

      handleFilterMarketerMode = (selectedFilterMarketerMode) => {
            this.setState({ selectedFilterMarketerMode: selectedFilterMarketerMode }, () => {
                  this.filterMarketerComission()
            })
      }

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleSelectRows = (row2) => {
            this.setState(
                {
                      marketer_commission_defult_id: row2.marketer_commission_defult_id,
                      marketer_commission_defult_percent: row2.marketer_commission_defult_percent,
                      marketer_commission_defult_wage: row2.marketer_commission_defult_wage,
                      selectedFieldinsurance: {
                            value: row2.marketer_commission_defult_fieldinsurance_id,
                            label: row2.fieldinsurance_fa,
                            logo: row2.fieldinsurance_logo_url,
                      },
                      selectedMarketerMode: {
                            value: row2.marketer_commission_defult_mode_id,
                            label: row2.marketer_mode_namefa,
                            logo: row2.marketer_mode_color,
                      },

                      marketer_mode_color: row2.marketer_mode_color,
                      fieldinsurance_logo_url: row2.fieldinsurance_logo_url,
                      newMarketerComission: false,
                },
                () => {}
            )
      }

      newMarketerComission = (event) => {
            this.setState({
                  marketer_commission_defult_id: "",
                  marketer_commission_defult_wage: "",
                  marketer_commission_defult_percent: "",
                  selectedFieldinsurance: "",
                  selectedMarketerMode: "",
                  marketer_mode_color: "",
                  fieldinsurance_logo_url: "",
                  newMarketerComission: true,
            })
      }
      componentDidMount() {
            if (this.cookies.get("employee_token_str")) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.getMarketerComission()
                                    self.getoptionMarketerMode()
                                    self.getoptionFieldinsurance()
                              } else if (arr.result === "error") {
                                    self.setState({ redirect: true })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "checkemployeelogin")

                  xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ redirect: true })
            }
      }

      getMarketerComission() {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ requestinfos: arr.data, agentInfofilter: arr.data }, () => {
                                    self.filterMarketerComission()
                              })
                        } else if (arr.result === "error") {
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_marketer_commission_defult")

            xhttp.open("POST", `${constants.BASE_URL}/comission`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      getoptionMarketerMode = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var MarketerMode = []
                              var MarketerMode1 = [{ value: 0, label: "همه انوع بازاریاب", logo: "" }]
                              for (var k = 0; k < arr.data.length; k++) {
                                    MarketerMode.push({
                                          value: arr.data[k].marketer_mode_id,
                                          label: arr.data[k].marketer_mode_namefa,
                                          logo: arr.data[k].marketer_mode_color,
                                    })
                                    MarketerMode1.push({
                                          value: arr.data[k].marketer_mode_id,
                                          label: arr.data[k].marketer_mode_namefa,
                                          logo: arr.data[k].marketer_mode_color,
                                    })
                              }
                              self.setState(
                                  {
                                        optionMarketerMode: MarketerMode,
                                        optionFilterMarketerMode: MarketerMode1,
                                        selectedFilterMarketerMode: MarketerMode1[0],
                                  },
                                  () => {}
                              )
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_marketer_mode")

            xhttp.open("POST", `${constants.BASE_URL}/comission`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      getoptionFieldinsurance = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              var Company1 = [{ value: 0, label: "همه رشته های بیمه", logo: "" }]
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({
                                          value: arr.data[k].fieldinsurance_id,
                                          label: arr.data[k].fieldinsurance_fa,
                                          logo: arr.data[k].fieldinsurance_logo_url,
                                    })
                                    Company1.push({
                                          value: arr.data[k].fieldinsurance_id,
                                          label: arr.data[k].fieldinsurance_fa,
                                          logo: arr.data[k].fieldinsurance_logo_url,
                                    })
                              }
                              self.setState(
                                  {
                                        optionFieldinsurance: Company,
                                        optionFilterFieldinsurance: Company1,
                                        selectedFilterFieldinsurance: Company1[0],
                                  },
                                  () => {}
                              )
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_fieldinsurance")
            xhttp.open("POST", `${constants.BASE_URL}/fieldinsurance`)
            xhttp.send(fd)
      }

      saveNewMarketerComission = () => {
            const { marketer_commission_defult_percent,marketer_commission_defult_wage, selectedFieldinsurance, selectedMarketerMode } = this.state
            if (selectedFieldinsurance != "" && selectedMarketerMode != "" && marketer_commission_defult_percent != ""&& marketer_commission_defult_wage != "") {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              console.log(this.responseText)
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    //self.setState({ redirect: true })
                                    self.getMarketerComission()
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_marketer_commission_defult")
                  fd.append("marketer_commission_defult_wage", marketer_commission_defult_wage)
                  fd.append("marketer_commission_defult_percent", marketer_commission_defult_percent)
                  fd.append("marketer_commission_defult_fieldinsurance_id", selectedFieldinsurance.value)
                  fd.append("marketer_commission_defult_mode_id", selectedMarketerMode.value)

                  xhttp.open("POST", `${constants.BASE_URL}/comission`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات شرکت و رشته بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      changeMarketerComission = () => {
            const { marketer_commission_defult_id, marketer_commission_defult_percent, marketer_commission_defult_wage, selectedFieldinsurance, selectedMarketerMode } = this.state
            if (selectedFieldinsurance != "" && selectedMarketerMode != "" && marketer_commission_defult_wage != ""&& marketer_commission_defult_percent != "") {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              console.log(this.responseText)
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    //self.setState({ redirect: true })
                                    self.getMarketerComission()
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "modify_marketer_commission_defult")
                  fd.append("marketer_commission_defult_id", marketer_commission_defult_id)
                  fd.append("marketer_commission_defult_wage", marketer_commission_defult_wage)
                  fd.append("marketer_commission_defult_percent", marketer_commission_defult_percent)

                  fd.append("marketer_commission_defult_fieldinsurance_id", selectedFieldinsurance.value)
                  fd.append("marketer_commission_defult_mode_id", selectedMarketerMode.value)

                  xhttp.open("POST", `${constants.BASE_URL}/comission`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات شرکت و رشته بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      createSortHandler = (field) => {
            if (this.state.orderBy === field) {
                  if (this.state.order === "asc") {
                        this.setState({ order: "desc" })
                  } else {
                        this.setState({ order: "asc" })
                  }
            } else {
                  this.setState({ orderBy: field, order: "asc" })
            }
            var arraytemp = [],
                i,
                j,
                temp,
                a,
                b
            arraytemp = this.state.agentInfofilter
            for (i = 0; i < arraytemp.length; i++) {
                  for (j = 0; j < arraytemp.length - 1; j++) {
                        a = arraytemp[j]
                        b = arraytemp[j + 1]
                        if (a[field] < b[field] && this.state.order === "asc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        } else if (a[field] > b[field] && this.state.order === "desc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        }
                  }
            }
      }

      handleChangeRowsPerPage = (event) => {
            this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 })
      }

      handleChangePage = (event, number) => {
            this.setState({ page: parseInt(number, 0) })
      }
      filterMarketerComission = () => {
            const { selectedFilterFieldinsurance, selectedFilterMarketerMode, requestinfos } = this.state
            var temparray = requestinfos,
                temparray2 = [],
                i
            for (i = 0; i < temparray.length; i++) {
                  if (
                      (selectedFilterMarketerMode.value === 0 ||
                          temparray[i].marketer_commission_defult_mode_id === selectedFilterMarketerMode.value) &&
                      (selectedFilterFieldinsurance.value === 0 ||
                          temparray[i].marketer_commission_defult_fieldinsurance_id === selectedFilterFieldinsurance.value)
                  ) {
                        temparray2.push(temparray[i])
                  }
            }
            this.setState({ agentInfofilter: temparray2 }, () => {})
      }

      render() {
            const { classes } = this.props
            const {
                  optionMarketerMode,
                  optionFilterMarketerMode,
                  optionFieldinsurance,
                  optionFilterFieldinsurance,
                  snackMode,
                  snackstr,
                  showSnack,
                  newMarketerComission,
                  marketer_commission_defult_id,
                  marketer_commission_defult_wage,
                  marketer_commission_defult_percent,
                  selectedFieldinsurance,
                  selectedFilterFieldinsurance,
                  marketer_mode_color,
                  fieldinsurance_logo_url,
                  selectedMarketerMode,
                  selectedFilterMarketerMode,
                  order,
                  orderBy,
                  okstatus,
                  errstr,
                  redirect,
                  agentInfofilter,
                  rowsPerPage,
                  page,
            } = this.state
            if (redirect) {
                  return <Redirect to="/" />
            } else {
                  return (
                      <div className={classes.paperrtl} dir="ltr">
                            <Snackbar
                                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                onClose={this.handleClickcloseTasckBar}
                                open={showSnack}
                                autoHideDuration={10000}
                            >
                                  <Alert severity={snackMode}>{snackstr}</Alert>
                            </Snackbar>
                            <Grid container spacing={3}>
                                  <Grid item xs={12}>
                                        <Container component="main" maxWidth="lg">
                                              <Paper elevation={4} className={classes.root}>
                                                    <Grid container spacing={3}>
                                                          <Grid item xs={6}>
                                                                <Typography align="center" variant="h7">
                                                                      {"شماره درصد بازاریابی: " + marketer_commission_defult_id}
                                                                </Typography>
                                                          </Grid>
                                                          <Grid item xs={6}></Grid>

                                                          <Grid item xs={6}>
                                                                <div style={{ width: "100%", textAlign: "center" }}>
                                                                      <img
                                                                          alt="Remy Sharp"
                                                                          className={classes.large}
                                                                          src={fieldinsurance_logo_url}
                                                                      />
                                                                </div>
                                                          </Grid>

                                                          <Grid item xs={6}>
                                                                <div style={{ width: "100%", textAlign: "center" }}>
                                                                      <Button variant="contained" style={{ background: marketer_mode_color }} />
                                                                </div>
                                                          </Grid>

                                                          <Grid item xs={6}>
                                                                <div>
                                                                      <label className="on">رشته بیمه</label>
                                                                      <Select
                                                                          isSearchable={true}
                                                                          className="adapter-txtsize"
                                                                          placeholder={"رشته بیمه"}
                                                                          value={selectedFieldinsurance}
                                                                          onChange={this.handleFieldinsurance}
                                                                          options={optionFieldinsurance}
                                                                      />
                                                                </div>
                                                          </Grid>

                                                          <Grid item xs={6}>
                                                                <div>
                                                                      <label className="on">نوع بازاریاب</label>
                                                                      <Select
                                                                          isSearchable={true}
                                                                          className="adapter-txtsize"
                                                                          placeholder={"نوع بازاریاب"}
                                                                          value={selectedMarketerMode}
                                                                          onChange={this.handleMarketerMode}
                                                                          options={optionMarketerMode}
                                                                      />
                                                                </div>
                                                          </Grid>

                                                          <Grid item xs={6}>
                                                                <FloatingLabelInput
                                                                    placeholder={"درصد بازاریابی "}
                                                                    handleInputt={this.handleChangeAmount}
                                                                    value={marketer_commission_defult_percent}
                                                                />
                                                          </Grid>

                                                          <Grid item xs={6}>
                                                                <FloatingLabelInput
                                                                    placeholder={"درصد بازاریابی روی شرکت و رشته "}
                                                                    handleInputt={this.handleChangeDefultPercent}
                                                                    value={marketer_commission_defult_wage}
                                                                />
                                                          </Grid>

                                                          <Grid item xs={12}>
                                                                {newMarketerComission ? (
                                                                    <Button
                                                                        variant="outlined"
                                                                        color="primary"
                                                                        onClick={this.saveNewMarketerComission}
                                                                    >
                                                                          {"ثبت درصد بازاریابی جدید "}
                                                                    </Button>
                                                                ) : (
                                                                    <div style={{ width: "100%", textAlign: "right" }}>
                                                                          <Button
                                                                              variant="outlined"
                                                                              color="primary"
                                                                              onClick={this.newMarketerComission}
                                                                          >
                                                                                {"درصد بازاریابی جدید "}
                                                                          </Button>
                                                                          {"          "}
                                                                          <Button
                                                                              variant="outlined"
                                                                              color="primary"
                                                                              onClick={this.changeMarketerComission}
                                                                          >
                                                                                {"ثبت تغییرات"}
                                                                          </Button>
                                                                    </div>
                                                                )}
                                                          </Grid>
                                                    </Grid>
                                              </Paper>
                                        </Container>
                                  </Grid>

                                  <Grid item xs={12}>
                                        <Container maxWidth="lg">
                                              <Paper className={classes.root}>
                                                    <Grid container spacing={3}>
                                                          <Grid item xs={6}>
                                                                <div>
                                                                      <label className="on">رشته بیمه</label>
                                                                      <Select
                                                                          isSearchable={true}
                                                                          className="adapter-txtsize"
                                                                          placeholder={"رشته بیمه"}
                                                                          value={selectedFilterFieldinsurance}
                                                                          onChange={this.handleFilterFieldinsurance}
                                                                          options={optionFilterFieldinsurance}
                                                                      />
                                                                </div>
                                                          </Grid>

                                                          <Grid item xs={6}>
                                                                <div>
                                                                      <label className="on">نوع بازاریاب</label>
                                                                      <Select
                                                                          isSearchable={true}
                                                                          className="adapter-txtsize"
                                                                          placeholder={"نوع بازاریاب"}
                                                                          value={selectedFilterMarketerMode}
                                                                          onChange={this.handleFilterMarketerMode}
                                                                          options={optionFilterMarketerMode}
                                                                      />
                                                                </div>
                                                          </Grid>
                                                    </Grid>
                                              </Paper>
                                        </Container>
                                  </Grid>

                                  <Grid item xs={12}>
                                        <Container maxWidth="lg">
                                              <Paper className={classes.root}>
                                                    <TableContainer dir="rtl">
                                                          <Table aria-label="sticky table">
                                                                <TableHead>
                                                                      <TableRow>
                                                                            <TableCell
                                                                                key={"marketer_commission_defult_id"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 20 }}
                                                                                sortDirection={
                                                                                      orderBy === "marketer_commission_defult_id" ? order : false
                                                                                }
                                                                            >
                                                                                  {" آی دی درصد بازاریابی"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "marketer_commission_defult_id"}
                                                                                      direction={
                                                                                            orderBy === "marketer_commission_defult_id"
                                                                                                ? order
                                                                                                : "asc"
                                                                                      }
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler(
                                                                                                "marketer_commission_defult_id"
                                                                                            )
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"marketer_mode_namefa"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {"نوع بازاریاب  "}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "marketer_mode_namefa"}
                                                                                      direction={
                                                                                            orderBy === "marketer_mode_namefa" ? order : "asc"
                                                                                      }
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("marketer_mode_namefa")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell></TableCell>

                                                                            <TableCell
                                                                                key={"fieldinsurance_fa"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {" رشته بیمه  "}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "fieldinsurance_fa"}
                                                                                      direction={orderBy === "fieldinsurance_fa" ? order : "asc"}
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("fieldinsurance_fa")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"marketer_commission_defult_percent"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {" درصد کمیسیون"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "marketer_commission_defult_percent"}
                                                                                      direction={
                                                                                            orderBy === "marketer_commission_defult_percent"
                                                                                                ? order
                                                                                                : "asc"
                                                                                      }
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler(
                                                                                                "marketer_commission_defult_percent"
                                                                                            )
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>
                                                                            <TableCell
                                                                                key={"marketer_commission_defult_wage"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {" درصد کمیسیون رشته و شرکت"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "marketer_commission_defult_wage"}
                                                                                      direction={
                                                                                            orderBy === "marketer_commission_defult_wage"
                                                                                                ? order
                                                                                                : "asc"
                                                                                      }
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler(
                                                                                                "marketer_commission_defult_wage"
                                                                                            )
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                      </TableRow>
                                                                </TableHead>

                                                                <TableBody>
                                                                      {agentInfofilter
                                                                          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                          .map((row) => {
                                                                                return (
                                                                                    <TableRow
                                                                                        hover
                                                                                        role="checkbox"
                                                                                        tabIndex={-1}
                                                                                        key={row["marketer_commission_defult_id"]}
                                                                                        value={row}
                                                                                        onClick={() => {
                                                                                              this.handleSelectRows(row)
                                                                                        }}
                                                                                    >
                                                                                          <TableCell
                                                                                              key={"marketer_commission_defult_id"}
                                                                                              align={"center"}
                                                                                          >
                                                                                                {row["marketer_commission_defult_id"]}
                                                                                          </TableCell>

                                                                                          <TableCell
                                                                                              key={"marketer_mode_namefa"}
                                                                                              align={"center"}
                                                                                          >
                                                                                                {row["marketer_mode_namefa"]}
                                                                                          </TableCell>

                                                                                          <TableCell>
                                                                                                <Button
                                                                                                    variant="contained"
                                                                                                    style={{
                                                                                                          background: row.marketer_mode_color,
                                                                                                    }}
                                                                                                />
                                                                                          </TableCell>

                                                                                          <TableCell key={"fieldinsurance_fa"} align={"center"}>
                                                                                                {row["fieldinsurance_fa"]}
                                                                                          </TableCell>

                                                                                          <TableCell align={"center"}>
                                                                                                {row["marketer_commission_defult_percent"]}
                                                                                          </TableCell>

                                                                                          <TableCell align={"center"}>
                                                                                                {row["marketer_commission_defult_wage"]}
                                                                                          </TableCell>
                                                                                    </TableRow>
                                                                                )
                                                                          })}
                                                                </TableBody>
                                                          </Table>
                                                    </TableContainer>
                                                    <TablePagination
                                                        rowsPerPageOptions={[10, 25, 100]}
                                                        component="div"
                                                        count={agentInfofilter.length}
                                                        rowsPerPage={rowsPerPage}
                                                        page={page}
                                                        onChangePage={this.handleChangePage}
                                                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                                    />
                                              </Paper>
                                        </Container>
                                  </Grid>
                            </Grid>

                            {okstatus ? (
                                <Alert severity="success">
                                      <AlertTitle>پیام</AlertTitle>
                                      {errstr}
                                </Alert>
                            ) : null}
                      </div>
                  )
            }
      }
}

export default withStyles(styles)(ChangeMarketerComission)
